export enum RestrictDurationUnitTypes {
  LimitMinutes = 1,
  LimitHours = 2,
  LimitDays = 3,
  LimitWeeks = 4,
  LimitMonths = 5,
}
